/**
 * Восстановление сессии при загрузке страницы.
 *
 * Порядок важен: сперва refresh по HttpOnly-cookie, только потом запрос
 * профиля. Обратный порядок дал бы 401 на каждой перезагрузке и выкидывал
 * пользователя на /login при живой сессии.
 */

import { useEffect, useRef } from "react";

import { useAppDispatch } from "@/app/hooks";
import { getWsClient, sessionApi, sessionEstablished, sessionLost } from "@taskflow/client-core";
import { refreshAccessToken } from "@/shared/auth/httpAuth";


export function useSessionBootstrap(): void {
  const dispatch = useAppDispatch();
  // StrictMode монтирует эффект дважды; восстановление должно пройти один раз.
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    void (async () => {
      const refreshed = await refreshAccessToken();
      if (!refreshed) {
        dispatch(sessionLost(null));
        return;
      }

      try {
        getWsClient().connect();
        const result = await dispatch(sessionApi.endpoints.me.initiate()).unwrap();
        dispatch(sessionEstablished(result));
      } catch {
        // Токен обновился, но профиль недоступен — сессия непригодна.
        dispatch(sessionLost("Не удалось загрузить профиль"));
      }
    })();
  }, [dispatch]);
}
